export const NOTIFICATION_REWRITE_PRESETS = [
    'formalize',
    'polish',
    'soften',
    'shorten'
];
